module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/home-7d040976d8e131abb9ed00f6090dc32c.jpg";